export function cartHoroshop() {
	const cartItemsContainer = document.querySelector(".cart-items");
	if(!cartItemsContainer) {
		return false;
	}

	const items = cartItemsContainer.querySelectorAll(".cart-item");

	const data = [];
	for(let i of items) {
		data.push({
			"title": i.querySelector(".cart-title a").innerHTML,
			"link": i.querySelector(".cart-title a").href,
			"price": i.querySelector(".cart-price").innerHTML
		});
	}

	return data;
}